import moment from 'moment'
import numeral from 'numeral'

export function bytesToSize (bytes, decimals = 2) {
  if (!bytes) return '0 Bytes';
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function durationToTime (time) {
  // Hours, minutes and seconds
  var hrs = ~~(time / 3600);
  var mins = ~~((time % 3600) / 60);
  var secs = ~~time % 60;

  // Output like '1:01' or '4:03:59' or '123:03:59'
  var ret = '';
  if (hrs > 0) {
    ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
  }
  ret += '' + mins + ':' + (secs < 10 ? '0' : '');
  ret += '' + secs;
  return ret;
}

export function formatDate (value, format) {
  if (value) {
    return moment(String(value)).format(format)
  }
  return null
}

export function numberFormat (str) {
  if (!str) return 0;
  return String(str).replace(/(.)(?=(\d{3})+$)/g, '$1,')
}

export function num (n) {
  if (!isFinite(n) || n === '') {
    return ''
  }
  return numeral(n).format('0,0')
}

export function strPad (str, length = 10, z = '0') {
  str = str + '';
  return str.length >= length ? str : new Array(length - str.length + 1).join(z) + str;
}

export function phoneNumber (str) {
  if (!str) return ''
  str = str.replace(/[^0-9]/g, '')
  return str.slice(0, 3) + str.slice(3, 7) + str.slice(7)
}

export function postCode (str) {
  if (!str) return ''
  str = str.replace(/[^0-9]/g, '')
  return str.slice(0, 3) + '-' + str.slice(3, 7)
}

export function hashCreditCard (str) {
  str = str.replace(/[^0-9]/g, '').substring(0, 16);
  if (str.length < 16) {
    str = strPad(str, 16)
  }
  let formatted = '';
  for (let i = 0, n = str.length; i < n; i++) {
    if (i && i % 4 === 0) {
      formatted += '-';
    }
    if (i >= str.length - 4) {
      formatted += str[i];
    } else {
      formatted += '*';
    }
  }
  return formatted
}

export function timestampToDate (time, format) {
  return moment.unix(time).format(format);
}



// WEBPACK FOOTER //
// ./src/filters/index.js